import { useState } from 'react';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import EditIcon from '@mui/icons-material/Edit';
import { FieldArray, useFormikContext } from 'formik';
import { v4 as uuidv4 } from 'uuid';
import { GridToolbarContainer, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid-premium';

import { dataGridPremiumColumns } from '../../utils/helper';
import { DataGridIdentifiers, AddButtonUi, DatagridPremiumUi, GridCellExpand, OrderArrowsUI } from '../Interface';
import DynamicFormCreatorDynFieldsDialog from './DynamicFormCreatorDynFieldsDialog';
import { DynmicFormFieldTypeOptions } from '../../config/DynmicFormFieldType';
import { moveDynamicFormField, normalizeDynamicFormFieldOrder } from '../../utils/dynamicFormFieldOrder';

const EditToolbar = (props) => {
  const { disabled, defaultDynamicFormField, setSelectedIndex } = props;
  const { values, setFieldValue } = useFormikContext();

  const handleClick = () => {
    const newField = {
      ...defaultDynamicFormField,
      id: uuidv4(),
      isNew: true,
      quantityUnitId: null,
      visOrder: values.dynamicFormField.length + 1,
    };
    const orderedFields = normalizeDynamicFormFieldOrder([...values.dynamicFormField, newField]);

    setFieldValue('dynamicFormField', orderedFields);
    setSelectedIndex(orderedFields.findIndex((field) => field.id === newField.id));
  };

  return (
    <GridToolbarContainer>
      <AddButtonUi disabled={disabled} onClick={handleClick} />
    </GridToolbarContainer>
  );
};
const DynamicFormCreatorDynFields = (props) => {
  const { disabled, defaultDynamicFormField } = props;
  const apiRef = useGridApiRef();
  const { values, setFieldValue } = useFormikContext();

  const [selectedIndex, setSelectedIndex] = useState(null);

  const getValueIndex = (values, id) => {
    return values.dynamicFormField.findIndex((rc) => rc.id === id);
  };

  const renderCellExpand = (data) => {
    return <GridCellExpand value={data.value || ''} width={data.colDef.computedWidth} />;
  };

  const handleOrderChange = (id, direction) => {
    setFieldValue('dynamicFormField', moveDynamicFormField(values.dynamicFormField, id, direction));
  };

  const handleRemove = (id) => {
    setFieldValue(
      'dynamicFormField',
      normalizeDynamicFormFieldOrder(values.dynamicFormField.filter((field) => field.id !== id))
    );
  };

  const columns = () => {
    return dataGridPremiumColumns([
      {
        field: 'visOrder',
        headerName: 'Sorrend',
        sortable: false,
        renderCell: ({ id, row }) => (
          <OrderArrowsUI
            onUpClick={() => handleOrderChange(id, 'up')}
            onDownClick={() => handleOrderChange(id, 'down')}
            disabled={disabled || Boolean(row.systemRole)}
          />
        ),
      },
      {
        field: 'name',
        headerName: 'Mező neve',
        type: 'string',
        sortable: false,
      },

      {
        field: 'type',
        headerName: 'Típus',
        type: 'string',
        sortable: false,
        renderCell: (data) => {
          return DynmicFormFieldTypeOptions.find((option) => option.value === data.value)?.label || '';
        },
      },

      {
        field: 'staticText',
        headerName: 'Statikus szöveg',
        type: 'string',
        sortable: false,
        renderCell: renderCellExpand,
      },
      {
        field: 'actions',
        type: 'actions',
        headerName: 'Szerk.',
        cellClassName: 'actions',
        sortable: false,
        getActions: ({ id, row }) => {
          return [
            <GridActionsCellItem
              icon={<DeleteIcon />}
              label="Delete"
              onClick={() => handleRemove(id)}
              color="inherit"
              disabled={disabled || Boolean(row.systemRole)}
            />,
            <GridActionsCellItem
              icon={<EditIcon />}
              label="Edit"
              onClick={() => {
                const valueIndex = getValueIndex(values, id);
                setSelectedIndex(valueIndex);
              }}
              color="inherit"
              disabled={disabled || Boolean(row.systemRole)}
            />,
          ];
        },
      },
    ]);
  };

  return (
    <>
      <div className="overflow-x-auto">
        <div className="align-middle">
          <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
            <FieldArray name="dynamicFormField">
              {({ remove }) => (
                <>
                  <DatagridPremiumUi
                    apiRef={apiRef}
                    datagridIdentifier={DataGridIdentifiers.DynamicFormField}
                    height={480}
                    columns={columns()}
                    rows={normalizeDynamicFormFieldOrder(values?.dynamicFormField)}
                    disableSave
                    pagination={false}
                    hideFooter
                    slots={{
                      toolbar: EditToolbar,
                    }}
                    slotProps={{
                      toolbar: {
                        disabled,
                        defaultDynamicFormField,
                        setSelectedIndex,
                      },
                    }}
                    onCellDoubleClick={(_params, event) => {
                      event.defaultMuiPrevented = true;
                    }}
                    headerFilters={false}
                    getRowHeight={() => 'auto'}
                  />
                  <DynamicFormCreatorDynFieldsDialog
                    selectedIndex={selectedIndex}
                    open={selectedIndex != null}
                    onClose={() => setSelectedIndex(null)}
                    remove={remove}
                    getValueIndex={getValueIndex}
                    {...props}
                  />
                </>
              )}
            </FieldArray>
          </div>
        </div>
      </div>
    </>
  );
};

export default DynamicFormCreatorDynFields;
